<template>
  <div class="home">
    <!-- 顶部横幅 -->
    <div class="header">
      <img src="https://pohto-imgs.oss-cn-beijing.aliyuncs.com/uploads/2026/0304/AEE90C20FEB66D23.png" alt="" style="width: 100%; height: auto;" />
    </div>
    <div class="title1" data-v-9807b647=""> 参观注册系统 <div class="back" data-v-9807b647="">参观注册系统</div></div>

    <!-- 注册按钮区域 -->
    <div class="homebtns">
      <!-- 个人观众注册 -->
      <div class="cards-container">
      <div class="visitor-card individual">
        <div class="icon-image-wrapper">
          <img style="height:3.5rem;" :src="sigleblack" class="icon-image icon-image-black" alt="个人参观注册图标">
  <img style="height:3.5rem;" :src="siglewhite" class="icon-image icon-image-white" alt="个人参观图标">
        </div>
        <h3>个人参观注册 Individual Visitor</h3>
        <p>截止时间: 2026年3月27日12:00<br/>DDL: 12:00, March 27, 2026</p>
        <div class="register-btn" @click="visitorReg"  style="background-color: white; color: #333; border: 1px solid #ccc; border-radius: 8px; padding: 10px 20px; font-size: 1em; cursor: pointer; text-align: center; margin-top: 10px; display: inline-block;">
  点击注册/Register →
</div>
      </div>

      <!-- 团体观众注册 -->
      <div class="visitor-card group">
        <div class="icon-image-wrapper">
          <img style="height:3.5rem;" :src="mutiwhite" class="icon-image icon-image-white" alt="团体参观注册图标">
  <img style="height:3.5rem;" :src="mutiblack" class="icon-image icon-image-black" alt="团体参观注册图标">

        </div>
        <h3>团体参观注册 Group Visitor</h3>
        <p>截止时间: 2026年3月27日12:00<br/>DDL: 12:00, March 27, 2026</p>
        <div class="register-btn" @click="groupreg"  style="background-color: white; color: #333; border: 1px solid #ccc; border-radius: 8px; padding: 10px 20px; font-size: 1em; cursor: pointer; text-align: center; margin-top: 10px; display: inline-block;">
  点击注册/Register →
</div>
      </div>
    </div>
    </div>

    <!-- 遮盖层和弹窗 -->
    <div v-if="showDialog" class="overlay"></div>
    <div v-if="showDialog" class="dialog">
      <div class="dialog-content">
        <p>观众报名已结束!</p>
      </div>
    </div>
<!-- 遮盖层和选择弹窗 -->
<div v-if="showSelectionDialog" class="selection-overlay" @click="closeSelectionDialog"></div>
    <div v-if="showSelectionDialog" class="selection-dialog-wrapper">
      <div class="selection-dialog">
        <div class="selection-dialog-content">
          <div class="selection-options">
            <div class="selection-option" @click="selectRegistrationType('cn')">
              <h4>中文注册</h4>
              <p>个人参观注册</p>
            </div>
            <div class="selection-option" @click="selectRegistrationType('en')">
              <h4>OverSea </h4>
              <p>Individual Visitor</p>
            </div>
          </div>
        </div>
      </div>
      <div class="selection-close-btn" @click="closeSelectionDialog">
        <van-icon name="cross" />
      </div>
    </div>

    <!-- 底部承办方信息 -->
    <div class="footer-info">
      承办方：北京泰格尔展览有限公司
    </div>
  </div>
</template>
<script setup>
import msg from '@/assets/zh/msg.png'
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { showToast } from 'vant'
import api from '@/api/index.js'
import { decryptionECB } from '@/utils/utils.js'
import wx from '@/utils/wx.js'
import { onMounted } from 'vue'
const showDialog = ref(false)

import sigleblack from'@/assets/sigleblack.png'
import siglewhite from '@/assets/siglewhite.png'
import mutiblack from '@/assets/mutiblack.png'
import mutiwhite from '@/assets/mutiwhite.png'
import sbar from '@/assets/vis/sbar.png'
const store = useStore()
const route = useRoute()
const invitesource = ref('')
const invitesourceID = ref('')
const lan = ref('')
const ExhCode = ref('')
const openid = computed(() => store.state.openid)
const queryObj = route.query
const showSelectionDialog = ref(false)
sessionStorage.clear()
sessionStorage.setItem('enterPath', route.path)
// 邀请参数
if (queryObj.invitesource) {
  invitesource.value = queryObj.invitesource
  sessionStorage.setItem('invitesource', queryObj.invitesource)
}
if (queryObj.invitesourceID) {
  invitesourceID.value = queryObj.invitesourceID
  sessionStorage.setItem('invitesourceID', queryObj.invitesourceID)
}
if (queryObj.lan) {
  lan.value = queryObj.lan
  sessionStorage.setItem('lan', queryObj.lan)
}
if (queryObj.IsGroup) {
  sessionStorage.setItem('IsGroup', queryObj.IsGroup)

}
if (queryObj.click_id) {
  sessionStorage.setItem('clickId', queryObj.click_id)
}
if (queryObj.c_id) {
  sessionStorage.setItem('clickId', queryObj.c_id)
}
if (queryObj.openid) {
  sessionStorage.setItem('openid', queryObj.openid)
}
//腾讯推广 - 从完整URL获取gdt_vid参数
const getUrlParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}
const gdtVid = getUrlParam('gdt_vid')
if (gdtVid) {
  sessionStorage.setItem('click_id', gdtVid)
}
const click_id = getUrlParam('click_id')
if (click_id) {
  sessionStorage.setItem('click_id', click_id)
}
// 也支持从 route.query 获取（hash路由场景）
if (route.query.click_id) {
  sessionStorage.setItem('click_id', route.query.click_id)
}
if (route.query.gdt_vid) {
  sessionStorage.setItem('click_id', route.query.gdt_vid)
}
if (queryObj.ExhCode) {
  ExhCode.value = queryObj.ExhCode
  store.commit('setExhCode', route.query.ExhCode)
} else {
  showToast({
    message: '展会参数缺失！',
    wordBreak: 'break-all',
    type: 'fail'
  })
}
// 英文链接地址
const enUrl = ref(
  `https://reg.alljoy.com.cn/VisitroRegist/26CEEC_EN/#/login?ExhCode=${ExhCode.value}&lan=en&invitesource=${invitesource.value}&invitesourceID=${invitesourceID.value}`
)
const isWeX = computed(() => store.state.isWeX)
if (/micromessenger/i.test(navigator.userAgent)) {
  store.commit('setIsWeX', true)
}

onMounted(() => {
  showDialog.value = false
})

const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }

  document.title = configObj.ExhibitionName || ''
  return configObj
}
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getToken = async () => {
  const res = await api.getTokenApi()
  store.commit('setToken', res.data.authorToken)
 // getOpenID()
  getGlobalConfig()
}
getToken()

const getGlobalConfig = async () => {
  const res = await api.getGConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const tmpObj = {}
    const resObj = JSON.parse(decryptionECB(res.data.configuartion))
    resObj.forEach((item) => {
      tmpObj[item.GlobalKey] = item.GlobalValue
    })
    store.commit('setGConfig', res.data.configuartion)
    store.commit('setMainColor', tmpObj.ButtonColor)
    // 判断展会是否关闭
    closeRes(gconfig.value.RegistStopTime)
    // closeRes('2023-02-04 14:00:00')
    if (isWeX.value) {
      wx.getWXSign()
    }
  }
}
const isClose = ref(false)
const closeRes = (str) => {
  const val = str.replace(/-/g, '/')
  isClose.value = new Date().getTime() >= new Date(val).getTime()
}

const router = useRouter()
const visitorReg = () => {
  showSelectionDialog.value = true
  return;

}
const selectRegistrationType = (type) => {
  if (type === 'cn')
  {
    const queryObj = {
      invitesource: invitesource.value,
      invitesourceID: invitesourceID.value,
      lan: lan.value,
      ExhCode: ExhCode.value
    }
    // 只有当openid.value存在且有值时才添加到参数中
    if (openid.value) {
      queryObj.openid = openid.value
    }
    console.log('queryObj', queryObj)
    router.push({
      path: '/loginForm',
      query: queryObj
    })
  }
  if(type === 'en')
  {
    const url = `https://reg.alljoy.com.cn/VisitroRegist/26ceec_EN/#/loginForm?lan=en&ExhCode=${ExhCode.value}&invitesource=${invitesource.value}&invitesourceID=${invitesourceID.value}`
  window.location.href = url
  }
}
const groupreg = () => {
console.log('groupReg')
  const url = `https://reg.alljoy.com.cn/VisitroRegist/26CEEC_Group/#/login?ExhCode=${ExhCode.value}&invitesource=${invitesource.value}&invitesourceID=${invitesourceID.value}`
  window.location.href = url
}

const getOpenID = () => {
  // 当前链接加获取时间
  const cUrl = window.location.href + '&time=' + Math.round(new Date() / 1000)
  if (isWeX.value) {
    if (cUrl.indexOf('openid') === -1) {
      if (cUrl.indexOf('InviteType') !== -1) {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}&InviteType=eg`
      } else {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}`
      }
    } else {
      // 如果有openid
      store.commit('setOpenID', route.query.openid)
      // 根据openid判断是否注册
      if (openid.value) {
        checkOpenid()
      } else {
        router.go(0)
      }
    }
  }
}
const checkOpenid = () => {
  api
    .checkIdentityLoginApi({
      openid: openid.value,
      ExhCode: ExhCode.value,
      aliID: ''
    })
    .then((res) => {
      if (res.code === 200) {
        if (res.data) {
          store.commit('setVisitorID', res.data.visitorID)
          sessionStorage.setItem('invitesourceID', res.data.visitorID)
          if (gconfig.value.SuccessPageVersion === 'V2') {
            router.push({ path: '/successV2' })
          } else {
            router.push({ path: '/success' })
          }
        }
      }
    })
}
const closeSelectionDialog = () => {
  showSelectionDialog.value = false
}

</script>
<style lang="less" scoped>
.body{
  background-color:#f7f8f9
}
// 在现有的<style lang="less" scoped>标签中添加以下样式
.cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
}

.visitor-card {
  flex: 1;
  min-width: 300px;
  max-width: 500px;

  @media (max-width: 768px) {
    min-width: 90%;
  }
}
.title1{
  padding: 1.5rem 1rem 0;
    position: relative;
    font-size: 2.4rem;
    font-weight: 700;
    text-align: left;
    font-family: syn;
    .back{
      position: absolute;
    font-size: 3.2rem;
    color: #0b243f0a;
    top: 1.4rem;
    left: 0rem;
    }
}
.register-btn {
  background-color: white;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 1em;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
  display: inline-block;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
    border-color: #999;
  }
}
.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  //padding: 0 20px;
  box-sizing: border-box;
  img {
    max-width: 100%;
    height: auto;
  }
}

.visitor-card {
  margin: 20px auto;
  width: 90%;
  max-width: 500px;
  padding: 20px;
  border-radius: 12px;
  text-align: left;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  @media (min-width: 769px) {
    &:hover {
      background-color: #f5f5f5;
    }
  }
  .icon {
    margin-bottom: 15px;
    svg {
      width: 48px;
      height: 48px;
    }
  }

  h3 {
    font-weight: 700;
    font-size: 1.3em;
    margin: 0;
  }

  p {
    margin: 10px 0;
    font-size: 1.0em;
  }

  .van-button {
    width: 100%;
    font-size: 1em;
    font-weight: 500;
  }
}

.individual {
  background: linear-gradient( 90deg, #091be1 0%, #0169d8 70%,  #01a9ed 100%);
  color: white;
  text-align: left;
  .van-button {
    color: white;
    border: none;
  }

  .icon-image-wrapper {
    position: relative;
    display: inline-block;

    .icon-image-black {
      display: none;
    }

    .icon-image-white {
      display: inline-block;
    }
  }



  // PC端悬停效果 - 保持渐变背景
  @media (min-width: 769px) {
    background: #fff !important;
    color:#000;

    // 默认状态下显示黑色图标
    .icon-image-wrapper {
      .icon-image-black {
        display: inline-block;
      }

      .icon-image-white {
        display: none;
      }
    }

    // 悬停状态下显示白色图标
    &:hover {
      color: white;
      background: linear-gradient(90deg, #091be1 0%, #0169d8 70%,  #01a9ed 100%) !important;

      .icon-image-wrapper {
        .icon-image-black {
          display: none;
        }

        .icon-image-white {
          display: inline-block;
        }
      }
    }
  }
}
  // 新增的选择弹窗样式，使用独立的类名避免冲突
  .selection-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.selection-dialog-wrapper {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.selection-dialog {
  background: white;
  border-radius: 12px;
  width: 90vw;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  .selection-dialog-content {
    padding: 0;

    .selection-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #eee;

      h3 {
        margin: 0;
        font-size: 1.2em;
        font-weight: 600;
      }

      .close-btn {
        font-size: 1.5em;
        cursor: pointer;
        color: #999;

        &:hover {
          color: #333;
        }
      }
    }

    .selection-options {
      padding: 20px;

      .selection-option {
        padding: 15px;
        border: 1px solid #eee;
        border-radius: 8px;
        margin-bottom: 15px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:last-child {
          margin-bottom: 0;
        }

        &:hover {
          border-color: #02599F;
          background-color: #f8f9fa;
        }

        h4 {
          margin: 0 0 5px 0;
          font-size: 1.1em;
          font-weight: 500;
        }

        p {
          margin: 0;
          font-size: 0.9em;
          color: #666;
        }
      }
    }
  }
}

// 移动端适配
@media (max-width: 768px) {
  .selection-dialog {
    width: 95vw;
  }
}

.selection-close-btn {
  margin-top: 20px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  color: #666;
  border: 1px solid #ddd;

  &:hover {
    color: #333;
    background: #fff;
  }
}

.group {
  color:#333;
  background-color: #fff;
  .icon-image-wrapper {
    position: relative;
    display: inline-block;

    .icon-image-black {
      display: inline-block;
    }

    .icon-image-white {
      display: none;
    }
  }
   // PC端悬停效果 - 添加浅灰色背景
   @media (min-width: 769px) {
    &:hover {
      color: white;
      background: linear-gradient( 90deg, #091be1 0%, #0169d8 70%,  #01a9ed 100%);
      .icon-image-black {
      display: none;
    }

    .icon-image-white {
      display: inline-block;
    }
    }
  }
  .van-button {
    color: #333;
    border: 1px solid #ccc;
  }
}

.footer-info {
  text-align: center;
 // padding: 20px;
  color: #666;
  font-size: 14px;
 // margin-top: 20px;
}

</style>
